import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useGoBack } from '@/common/hooks/useGoBack'
import { useDeleteMaintenanceWorkflowSchedule } from '../hooks/useDeleteWorkflowSchedules'

interface ModalDeleteMaintenanceWorkflowScheduleProps {
  workflowScheduleId?: string
  onError?: (error: ErrorResponse) => void
}

export const ModalDeleteMaintenanceWorkflowSchedule = ({ workflowScheduleId, onError }: ModalDeleteMaintenanceWorkflowScheduleProps) => {
  const queryClient = useQueryClient()
  const goBack = useGoBack()

  const [isOpen, setIsOpen] = useState(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['workflowSchedule', workflowScheduleId] })
    queryClient.invalidateQueries({ queryKey: ['workflowSchedules'] })
    goBack({fallback: `/maintenance-workflows-schedules`})
  }

  const { mutate: deleteWorkflowSchedule, isPending: deleteWorkflowScheduleIsPending } = useDeleteMaintenanceWorkflowSchedule({
    onSuccess,
    onError: (error) => {
      setIsOpen(false)
      onError?.(error)
    },
  })

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission='Client::Maintenance::WorkflowSchedules::Destroy' type="button" variant="outline-error">
          Deletar
        </Button>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Deletar programação"
      disabled={deleteWorkflowScheduleIsPending}
      onConfirm={() => deleteWorkflowSchedule(workflowScheduleId)}
    />
  )
}
